import './ProgressContainer.scss';
import '../FileUploader.scss';
import 'antd/lib/progress/style/index.css';

import { colorBlue2, colorGray3 } from '@hulu/design-tokens/lib/colors.common';
import { Typography } from '@hulu/react-style-components';
import { Progress } from 'antd';
import React from 'react';

import bem from '../../../utils/bem';
import Button from '../../Button';

const [, element] = bem('progress-container');
const [, fileUploaderElement] = bem('file-uploader');

type Props = {
  percentUploaded?: number;
  cancelRequest: () => void;
  uploadMessage: React.JSX.Element;
};

const ProgressContainer = ({ cancelRequest, percentUploaded, uploadMessage }: Props): React.JSX.Element => {
  return (
    <div className={fileUploaderElement('dropzone')}>
      <span className={element('upload-message')}>{uploadMessage}</span>
      <Progress
        className={element('progress-bar')}
        percent={percentUploaded}
        strokeColor={colorBlue2}
        trailColor={colorGray3}
        strokeWidth={7}
        success={{
          strokeColor: colorBlue2,
        }}
        showInfo={false}
        data-testid="progress-bar"
      />
      <div className={element('progress-details')}>
        {percentUploaded && <Typography variant="body3">{`${percentUploaded.toFixed(0)}% complete`}</Typography>}
        <Button variant="outlined" className={element('cancel-btn')} onClick={cancelRequest}>
          <Typography variant="link3">Cancel</Typography>
        </Button>
      </div>
    </div>
  );
};

export default ProgressContainer;
